import { ACTION_LOGOUT } from "@login/reducer/actions.type";
import {
  SET_LOYALTY_RESET,
  SET_LOYALTY_STORE,
  FETCH_LOYALTY_ACCOUNT_FAILURE,
  FETCH_LOYALTY_ACCOUNT_REQUEST,
  FETCH_LOYALTY_ACCOUNT_SUCCESS,
  FETCH_LINK_WEBVIEW_LOYALTY_REQUEST,
  FETCH_LINK_WEBVIEW_LOYALTY_SUCCESS,
  FETCH_LINK_WEBVIEW_LOYALTY_FAILURE,
} from "./actions.type";
import { LoyaltyActions, LoyaltyState } from "./types";

const initialState: LoyaltyState = {
  resAccount: undefined,
  resLinkWebview: undefined,
  statusLoyalty: "pending",
};

export default (state = initialState, action: LoyaltyActions): LoyaltyState => {
  switch (action.type) {
    case FETCH_LOYALTY_ACCOUNT_REQUEST:
      return {
        ...state,
        statusLoyalty: "pending",
      };
    case FETCH_LOYALTY_ACCOUNT_SUCCESS:
      return {
        ...state,
        resAccount: action.payload,
        statusLoyalty: "ok",
      };
    case FETCH_LOYALTY_ACCOUNT_FAILURE:
      return {
        ...state,
        statusLoyalty: "error",
      };
    case FETCH_LINK_WEBVIEW_LOYALTY_REQUEST:
      return {
        ...state,
        resLinkWebview: undefined,
      };
    case FETCH_LINK_WEBVIEW_LOYALTY_SUCCESS:
      return {
        ...state,
        resLinkWebview: action.payload,
      };
    case FETCH_LINK_WEBVIEW_LOYALTY_FAILURE:
      return {
        ...state,
      };
    case SET_LOYALTY_STORE:
      return {
        ...state,
        ...action.payload,
      };
    case SET_LOYALTY_RESET:
      return {
        ...initialState,
      };
    case ACTION_LOGOUT:
      return {
        ...initialState,
      };
    default:
      return {
        ...state,
      };
  }
};
